import { GACustom, EventData, EventPayload, PageViewPayload } from './types';
import { transformToGACustomPayload, CustomParamsForGAEvent } from './utilsGA';

const analyticsApiClient = () => {
  const categoryName = 'self_serve_actions';

  const sendAnalyticsEvent = (
    payload: EventPayload | PageViewPayload,
  ): void => {
    if (window && window.sendEvent) {
      window.sendEvent(payload);
    }
  };

  /**
   * Sends a regular labeled event.
   * @param {object} data – The log settings.
   * @param {string} data.label – The event label.
   * @param {string} [data.action] – Optional event action. Defauls
   * to the actionName provided on instantiation.
   * @param {Object} [customData] Optional param containing additional data.
   */
  const sendEvent = (
    data: EventData,
    customData?: GACustom,
    eventName?: string,
  ): void => {
    const payload: EventPayload = {
      event_category: eventName || categoryName,
      event_label: data.label || '',
      event_action: data.action || 'appointment',
    };

    if (customData?.custom) {
      payload.custom = customData.custom;
    }
    if (customData?.params) {
      payload.params = customData.params;
    }

    sendAnalyticsEvent(payload);
  };

  /**
   * Sends a pageview event with custom parameters if provided.
   * Used upon arrival to a page, route or view f.e.
   * Example of `custom` data:
   * { version: '1.2.3', page_type: 'events', local_store: '123' }
   * @param {Object} [custom] – an optional object for the `custom` prop.
   */
  const sendPageview = (custom?: object): void => {
    if (!window || !window.location) {
      return;
    }

    const payload: PageViewPayload = {
      event_category: 'pageview',
      page_path: window.location.pathname || '',
      page_location: window.location.href || '',
    };

    if (custom && Object.keys(custom).length > 0) {
      payload.custom = custom;
    }

    sendAnalyticsEvent(payload);
  };

  const handleEventInGoogleAnalytic = (
    label: string,
    customData?: CustomParamsForGAEvent,
  ): void => {
    const customPayload = customData && transformToGACustomPayload(customData);
    sendEvent(
      {
        label,
        action: 'appointment',
      },
      customPayload,
    );
  };

  return {
    handleEventInGoogleAnalytic,
    sendPageview,
  };
};

export default analyticsApiClient;
